import { Card, CardContent, CardHeader, Divider, makeStyles, Button, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import Filter from './components/Filter'
import AccountsTable from './components/AccountsTable'
import AddAccount from './components/AddAccount'
import Popup from '../../components/Popup'

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 100,
        padding: theme.spacing(1)
    },
    content: {
        marginTop: theme.spacing(3)
    },
}))

const Accounts = () => {
    const classes = useStyles()
    const [addAccountPopup, setAddAccountPopup] = useState(false)
    return (
        <Card className={classes.root}>
            <CardHeader title="حساب ها" action={
                <Button variant="contained" color="primary" onClick={() => setAddAccountPopup(true)}>
                    اضافه کردن حساب
                    </Button>
            } />
            <Popup
                title="اضافه کردن حساب"
                openPopup={addAccountPopup}
                setOpenPopup={setAddAccountPopup}
            >
                <AddAccount setPopup={setAddAccountPopup} />
            </Popup>
            <Divider />
            <CardContent>
                <Filter />
                <Grid className={classes.content}>
                    <AccountsTable />
                </Grid>
            </CardContent>
        </Card>
    )
}

export default Accounts
